import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import NavigationItems from "../NavigationItems/NavigationItems";

import classes from "./Toolbar.module.css";

import logo from "../../../assets/images/logo-02.svg";
import logoTM from "../../../assets/images/logo-trustmark.svg";
import ampsWatermark from "../../../assets/images/amps-logo-watermark.png";

interface IStateFromProps {
  appConfig: {
    theme: string;
    logos: string[];
  };
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  isWatermark: boolean;
}
type Props = IStateFromProps;

class Toolbar extends Component<Props> {
  render() {
    return (
      <Fragment>
        <header className={classes.Toolbar}>
          <div className="Logo">
            {this.props.config_values &&
            this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() === "Home".toLowerCase() &&
                ele.element.toLowerCase() === "Logo".toLowerCase()
            ) ? (
              this.props.config_values.find(
                (ele) =>
                  ele.targetPageTitle.toLowerCase() === "Home".toLowerCase() &&
                  ele.element.toLowerCase() === "Logo".toLowerCase()
              )?.customValue ? (
                <Link to="/">
                  <Image
                    src={
                      this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Home".toLowerCase() &&
                            ele.element.toLowerCase() === "Logo".toLowerCase()
                        )
                        ?.customValue?.split("\n")[0]
                    }
                    alt="home logo"
                  />
                </Link>
              ) : (
                <Link to="/">
                  <Image
                    src={
                      this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Home".toLowerCase() &&
                            ele.element.toLowerCase() === "Logo".toLowerCase()
                        )
                        ?.defaultValue.split("\n")[0]
                    }
                    alt="home logo"
                  />
                </Link>
              )
            ) : this.props.appConfig &&
              this.props.appConfig.theme.toLowerCase() === "amps" ? (
              <Link to="/">
                <Image src={logo} alt="home logo" className="am-logo" />
              </Link>
            ) : (
              <Link to="/">
                <Image src={logoTM} alt="home logo" className="tm-logo" />
              </Link>
            )}
            {/* {this.props.appConfig &&
          this.props.appConfig.logos &&
          this.props.appConfig.logos.length > 0 ? (
            <Link to="/">
              <Image src={this.props.appConfig.logos[0]} alt="home logo" />
            </Link>
          ) : this.props.appConfig &&
            this.props.appConfig.theme.toLowerCase() === "amps" ? (
            <Link to="/">
              <Image src={logo} alt="home logo" className="am-logo"/>
            </Link>
          ) : (
            <Link to="/">
              <Image src={logoTM} alt="home logo" className="tm-logo"/>
            </Link>
          )} */}
          </div>
          <nav className={classes.DesktopOnly}>
            <NavigationItems />
          </nav>
        </header>
        {this.props.isWatermark && (
          <div className="logo-watermark">
            <Image src={ampsWatermark} alt="AMPS" />
          </div>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  appConfig: state.appConfig.appConfig,
  config_values: state.appConfig.config_values,
  isWatermark: state.appConfig.isWatermark,
});
export default connect(mapStateToProps)(Toolbar);
